<div class="card-body">
    <div id="apex-radialbars-with-image"></div>
</div>